import { render } from "./TourPage.vue?vue&type=template&id=28f76000&scoped=true"
import script from "./TourPage.vue?vue&type=script&lang=js"
export * from "./TourPage.vue?vue&type=script&lang=js"

import "./TourPage.vue?vue&type=style&index=0&id=28f76000&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28f76000"]])

export default __exports__